import { render, staticRenderFns } from "./FeedToggler.vue?vue&type=template&id=f45d7b40&"
import script from "./FeedToggler.vue?vue&type=script&lang=js&"
export * from "./FeedToggler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports